<script setup lang="ts">
const m2Product = inject('m2Product')
</script>

<template>
  <LazyUiDialog
    name="design-story-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ $t('The story behind the design') }}</span>
    </template>

    <UiRichtext :html="m2Product.description.html" />
  </LazyUiDialog>
</template>
